import axios from 'axios'
import { message } from 'antd'
import { replace } from 'connected-react-router/immutable'
import { objectToQuery } from '@utils/config'
import tokenHelper from '../utils/tokenHelper'
import { getStore } from '../utils/storeHelper'
import CODE from './code'

const instance = axios.create({
  baseURL: `${process.env.ORIGIN}internal/`,
  // baseURL: `http://shield-dev.qipeng.com/internal/`,

  timeout: 30000
})

const headerDefaultContentType = {
  GET: 'application/x-www-form-urlencoded; charset=utf-8',
  POST: 'application/json; charset=utf-8',
  DELETE: 'application/x-www-form-urlencoded; charset=utf-8',
  PUT: 'application/json; charset=utf-8'
}

// 拦截器
instance.interceptors.request.use(config => {
  const copyConfig = config
  const token = tokenHelper.getToken()
  if (token) {
    copyConfig.headers.common['X-Sa-Token'] = token
  }
  return copyConfig
})

instance.interceptors.response.use(response => {
  return response
})

/**
 *
 * @param url
 * @param method
 * @param params
 * @param headers
 */
function request(url = '/', method = 'GET', params = null, headers = {}, timeout = 0) {
  const defaultHeader = headerDefaultContentType[method]
  const store = getStore()
  return new Promise((resolve, reject) => {
    let body = params
    let endUrl = url
    if (method === 'POST' || method === 'PUT') {
      // 上传文件的单独处理
      if (headers['Content-Type'] === 'multipart/form-data') {
        body = params
      } else {
        body = JSON.stringify(params)
      }
    } else if (params) {
      endUrl = `${url}?${objectToQuery(params)}`
      body = null
    }
    // eslint-disable-next-line no-param-reassign
    // headers.accept = 'application/json';
    instance
      .request({
        url: endUrl,
        method,
        data: body,
        headers: {
          'Content-Type': defaultHeader,
          ...headers
        },
        timeout
      })
      .then(res => {
        const data = res.data || {}
        const { code } = data
        if (code === CODE.notlogin) {
          window.location = `
            ${process.env.ORIGIN}internal/staff/login?callback=${encodeURIComponent(
            window.location.href
          )}`
        } else if (code === CODE.noprivilege) {
          const { getState, dispatch } = store
          const state = getState()
          const location = state.getIn(['router', 'location']).toObject()
          dispatch(replace({ pathname: '/error', state: { location, type: 'privilege' } }))
          throw new Error('权限不足')
        } else if (code === CODE.ok) {
          resolve(data.data)
        } else {
          message.error(data.msg)
          reject(data)
        }
      })
      .catch(e => {
        message.error(e.message)
        reject(e)
      })
  })
}

const fetch = {
  get(url = '/', para = {}, header = {}, timeout) {
    return request(url, 'GET', para, header, timeout)
  },
  post(url = '/', para = {}, header = {}, timeout) {
    return request(url, 'POST', para, header, timeout)
  },
  delete(url = '/', para = {}, header = {}, timeout) {
    return request(url, 'DELETE', para, header, timeout)
  },
  put(url = '/', para = {}, header = {}, timeout) {
    return request(url, 'PUT', para, header, timeout)
  }
}

export default fetch
